import React from 'react';


const SideMenu = (props) => {
  // const [sectionSelected, setSectionSelected] = useState(0);
  return (
    <div className="side-menu">
      <h2 className="menu-title">
        Administration Menu
      </h2>
      <hr className="title-separator" />
      <div className="menu-sections">
        <div className={`menu-section ${props?.sectionSelected === 0 ? "selected" : ''}`} onClick={() => props.setSectionSelected(0)}>
          Application Data
        </div>
        <div className={`menu-section ${props?.sectionSelected === 1 ? "selected" : ''}`} onClick={() => props.setSectionSelected(1)}>
          Application Configurations
        </div>
        <div className={`menu-section ${props?.sectionSelected === 2 ? "selected" : ''}`} onClick={() => props.setSectionSelected(2)}>
          Email/SMS Templates
        </div>
        <div className={`menu-section ${props?.sectionSelected === 3 ? "selected" : ''}`} onClick={() => props.setSectionSelected(3)}>
          Language Configuration and Strings
        </div>
        <hr className="title-separator" />
        <h2 className="menu-title2">
          User management
        </h2>
        <hr className="title-separator" />
        <div className={`menu-section ${props?.sectionSelected === 4 ? "selected" : ''}`} onClick={() => props.setSectionSelected(4)}>
          Users
        </div>
        <div className={`menu-section ${props?.sectionSelected === 5 ? "selected" : ''}`} onClick={() => props.setSectionSelected(5)}>
          Groups
        </div>
      </div>
    </div>
  );
};

export default SideMenu;
